/**
 * Ids of the folders above one, nearest first, following `parent` links
 * through the given map (loaded folders, virtual forms folders included).
 * Stops at a parent the map lacks and at one already met, so a row that is
 * its own ancestor cannot spin it.
 * @param {Object<string, Object>} foldersById
 * @param {string} folderId
 * @returns {string[]}
 */
export const getFolderAncestorIds = (foldersById, folderId) => {
  const ancestors = [];
  if (!foldersById || !folderId || !foldersById[folderId]) return ancestors;

  const seen = new Set([folderId]);
  let parentId = foldersById[folderId].parent;
  while (parentId && foldersById[parentId] && !seen.has(parentId)) {
    seen.add(parentId);
    ancestors.push(parentId);
    parentId = foldersById[parentId].parent;
  }

  return ancestors;
};
